module.exports = __webpack_public_path__ + "media/images/logo/vk-901926bacb223e0e71a6941fd05bd215.svg";